import type { ComponentProps } from "react";
import { CompanyNameReviewPanel } from "../company-name-review-panel";
import { DsdReviewBackButton } from "../panel/back-button";
import { DsdReviewGuideCard } from "../guide-card";

/** 기업명 확인 패널 — 목록·상세(company-name-review-panel) 위에 머리를 안내 카드로 얹는다 (교정 패널과 같다) */
export const DsdReviewCompanyNamePanel = ({
  count,
  onBack,
  ...panelProps
}: Omit<ComponentProps<typeof CompanyNameReviewPanel>, "header"> & {
  count: number;
  /** 상세 → 목록 */
  onBack: () => void;
}) => (
  <CompanyNameReviewPanel
    {...panelProps}
    header={(isDetail) => (
      <>
        <div className="shrink-0 p-4">
          <DsdReviewGuideCard
            mode="company-name-review"
            count={count}
            variant="embedded"
            collapsed={isDetail}
          />
        </div>
        {isDetail && <DsdReviewBackButton onBack={onBack} />}
      </>
    )}
  />
);
